import React, { useState, useEffect, useRef } from "react";
import "./../../../assets/css/purchase/form.css";

import moment from "moment";

import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ItemModal from "../../components/Modal/ItemModal";
import DatePicker from "../../components/DatePicker";
import { exportHtmlTableToExcel } from "../../../utils/ExportUtils";
import { getAlert, getDataWithJoin, getData } from "../../../utils/SamuiUtils";
import { useEscapeClose } from "../../../utils/SamuiUtils";

const MaterialMovementReport = () => {
  const [name, setName] = useState(null);
  const [searchCriteria, setSearchCriteria] = useState({});
  const [filteredData, setFilteredData] = useState([]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [showItemModal, setShowItemModal] = useState(false);
  const [itemsList, setItemsList] = useState([]);

  const [warehouseList, setWarehouseList] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("");

  const [selectedRow, setSelectedRow] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(16);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const [isExporting, setIsExporting] = useState(false);
  const tableRef = useRef(null);

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const pages = [];
    const maxVisiblePages = 5;
    const range = 2;

    if (totalPages > maxVisiblePages) {
      pages.push(
        <li
          key={1}
          className={`paginate_button page-item ${currentPage === 1 ? "active" : ""
            }`}
        >
          <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
            1
          </a>
        </li>
      );

      if (currentPage - range > 2) {
        pages.push(
          <li key="ellipsis-start" className="paginate_button page-item">
            <a href="#" className="page-link">
              ...
            </a>
          </li>
        );
      }

      for (
        let i = Math.max(currentPage - range, 2);
        i <= Math.min(currentPage + range, totalPages - 1);
        i++
      ) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""
              }`}
          >
            <a href="#" className="page-link" onClick={() => setCurrentPage(i)}>
              {i}
            </a>
          </li>
        );
      }

      if (currentPage + range < totalPages - 1) {
        pages.push(
          <li key="ellipsis-end" className="paginate_button page-item">
            <a href="#" className="page-link">
              ...
            </a>
          </li>
        );
      }

      pages.push(
        <li
          key={totalPages}
          className={`paginate_button page-item ${currentPage === totalPages ? "active" : ""
            }`}
        >
          <a
            href="#"
            className="page-link"
            onClick={() => setCurrentPage(totalPages)}
          >
            {totalPages}
          </a>
        </li>
      );
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""
              }`}
          >
            <a href="#" className="page-link" onClick={() => setCurrentPage(i)}>
              {i}
            </a>
          </li>
        );
      }
    }

    return pages;
  };

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    setName("12. รายงานวัสดุเคลื่อนไหว");
    setSearchCriteria({
      startDate: moment(),
      endDate: moment(),
    });
    setFilteredData([]);
    setSelectedItem(null);
    setSelectedWarehouse("");

    await loadWarehouseList();
    await loadItemsList();
  };

  const loadWarehouseList = async () => {
    try {
      let response = null;

      try {
        response = await getDataWithJoin(
          "WH_Id, WH_Code, WH_Name",
          "View_Set_WH",
          `WHERE Comp_Id = '${window.localStorage.getItem("company")}'`,
          "ORDER BY WH_Code ASC"
        );
      } catch (error1) {
        try {
          response = await getData(
            "Tb_Set_WH",
            "WH_Id, WH_Code, WH_Name",
            `Comp_Id = '${window.localStorage.getItem("company")}' ORDER BY WH_Code ASC`
          );
        } catch (error2) { }
      }

      if (response && response.length > 0) {
        setWarehouseList(response);
      } else {
        setWarehouseList([]);
        getAlert("ERROR", "An Error Occurred While Querying The Database.");
      }
    } catch (error) {
      setWarehouseList([]);
      getAlert("ERROR", "An Error Occurred While Querying The Database.");
    }
  };

  const loadItemsList = async () => {
    try {
      let response = null;

      try {
        response = await getDataWithJoin(
          "Item_Id, Item_Code, Item_Name",
          "API_0002_Set_Item",
          `WHERE Comp_Id = '${window.localStorage.getItem("company")}'`,
          "ORDER BY Item_Code ASC"
        );
      } catch (error1) {
        try {
          response = await getData(
            "API_0002_Set_Item",
            "Item_Id, Item_Code, Item_Name",
            `Comp_Id = '${window.localStorage.getItem("company")}' ORDER BY Item_Code ASC`
          );
        } catch (error2) {
          try {
            response = await getData(
              "Tb_Set_Item",
              "Item_Id, Item_Code, Item_Name",
              `Comp_Id = '${window.localStorage.getItem("company")}' ORDER BY Item_Code ASC`
            );
          } catch (error3) {
            try {
              response = await getData(
                "View_Set_Item",
                "Item_Id, Item_Code, Item_Name",
                `Comp_Id = '${window.localStorage.getItem("company")}' ORDER BY Item_Code ASC`
              );
            } catch (error4) { }
          }
        }
      }

      if (response && response.length > 0) {
        setItemsList(response);
      } else {
        setItemsList([]);
        getAlert("ERROR", "An Error Occurred While Querying The Database.");
      }
    } catch (error) {
      setItemsList([]);
      getAlert("ERROR", "An Error Occurred While Querying The Database.");
    }
  };

  const handleChangeDate = (value, name) => {
    setSearchCriteria((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleExport = async () => {
    if (!filteredData || filteredData.length === 0) {
      getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    if (!tableRef.current) {
      getAlert("FAILED", "ไม่พบตารางข้อมูลสำหรับ Export");
      return;
    }

    try {
      setIsExporting(true);
      const fileName = `material-movement-report_${moment().format(
        "YYYYMMDD_HHmmss"
      )}.xlsx`;
      await exportHtmlTableToExcel(tableRef.current, {
        sheetName: name || "รายงานวัสดุเคลื่อนไหว",
        fileName,
        headerLines: [
          name || "รายงานวัสดุเคลื่อนไหว",
          selectedItem
            ? `วัสดุ: ${selectedItem.Item_Code || "-"} - ${selectedItem.Item_Name || "-"}`
            : "",
        ],
      });
    } catch (error) {
      console.error("Export material movement report error:", error);
      getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    } finally {
      setIsExporting(false);
    }
  };

  const handleSearch = async () => {
    try {
      setFilteredData([]);

      // Validation
      if (!selectedItem) {
        getAlert("WARNING", "กรุณาเลือกวัสดุ");
        return;
      }

      if (!selectedWarehouse) {
        getAlert("WARNING", "กรุณาเลือกคลัง");
        return;
      }

      if (!searchCriteria.startDate || !searchCriteria.endDate) {
        getAlert("WARNING", "กรุณาเลือกช่วงวันที่");
        return;
      }

      let compId = "";
      try {
        const companyData = localStorage.getItem("company");
        if (companyData) {
          compId = companyData || "";
        }
      } catch (error) {
        console.error("Error parsing company data:", error);
        getAlert("ERROR", "ไม่สามารถอ่านข้อมูลบริษัทได้");
        return;
      }

      if (!compId) {
        getAlert("ERROR", "ไม่พบข้อมูลบริษัท");
        return;
      }

      // Format dates with timezone offset (+7 hours)
      const startDate = moment(searchCriteria.startDate).format("YYYY-MM-DD");
      const endDate = moment(searchCriteria.endDate).format("YYYY-MM-DD");

      const whereCondition = `WHERE STC.Item_Id = '${selectedItem.Item_Id}' 
                              AND STC.Comp_Id = '${compId}' 
                              AND STC.WH_Id = '${selectedWarehouse}' 
                              AND STC.STC_Date BETWEEN '${startDate}' AND '${endDate}' 
                              ORDER BY STC.STC_SEQ DESC`;

      const selectFields = `STC.STC_Date, STC.STC_Remark, STC.Doc_No, 
                            CASE 
                              WHEN STC.Doc_Type = 'AI' OR STC.Doc_Type = 'TI' OR STC.Doc_Type = 'IN' THEN STC.STC_QTY
                            END AS movement_in,
                            CASE 
                              WHEN STC.Doc_Type = 'AO' OR STC.Doc_Type = 'TO' OR STC.Doc_Type = 'OUT' THEN STC.STC_QTY
                            END AS movement_out, 
                            STC.STC_Balance, ITM.Item_Price,
                            CASE 
                              WHEN STC.Doc_No LIKE 'REC%' THEN '-'
                              WHEN STC.Doc_No LIKE 'OE%' OR STC.Doc_No LIKE 'IB%' THEN COALESCE(WTH.WTDoc_Emp_Name, '-')
                              ELSE COALESCE(WDH.WHDoc_Cust_Name, '-')
                            END AS Requestor_Name,
                            CASE 
                              WHEN STC.Doc_No LIKE 'REC%' THEN COALESCE(RH.AP_Name, '-')
                              ELSE '-'
                            END AS Shop_Name`;

      const fromTable = `API_1201_WH_ITEM_STC STC`;

      const joinTables = `LEFT JOIN API_0002_Set_Item ITM ON ITM.Item_Id = STC.Item_Id
                          LEFT JOIN API_1001_WHDOC_H WDH ON WDH.WHDoc_No = STC.Doc_No AND WDH.Comp_Id = STC.Comp_Id
                          LEFT JOIN API_1601_WTDOC_H WTH ON WTH.WTDoc_No = STC.Doc_No AND WTH.Comp_Id = STC.Comp_Id
                          LEFT JOIN API_0301_REC_H RH ON RH.Rec_No = STC.Doc_No AND RH.Comp_Id = STC.Comp_Id`;

      const response = await getDataWithJoin(
        selectFields,
        fromTable,
        joinTables,
        whereCondition
      );

      setFilteredData(response || []);
    } catch (error) {
      getAlert("ERROR", "An Error Occurred While Querying The Database.");
    }
  };

  const handleItemClose = () => {
    setShowItemModal(false);
  };

  const onRowSelectItem = (selectedItemsFromModal) => {
    // เลือกได้เพียงรายการเดียว
    if (selectedItemsFromModal && selectedItemsFromModal.length > 0) {
      setSelectedItem(selectedItemsFromModal[0]);
    }
    setShowItemModal(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("DD/MM/YYYY");
  };

  const formatNumber = (number) => {
    if (!number) return "0.00";
    return Number(number).toLocaleString("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <>
      <Sidebar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/material-movement-report" },
                ]}
              />
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <DatePicker
                          label="วันที่เริ่มต้น"
                          name="startDate"
                          value={searchCriteria.startDate}
                          onChange={(date) =>
                            handleChangeDate(date, "startDate")
                          }
                          disabled={false}
                        />
                      </div>
                      <div className="col-md-3">
                        <DatePicker
                          label="วันที่สิ้นสุด"
                          name="endDate"
                          value={searchCriteria.endDate}
                          onChange={(date) => handleChangeDate(date, "endDate")}
                          disabled={false}
                        />
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>วัสดุ:</label>
                          <div className="d-flex">
                            <button
                              type="button"
                              className="btn text-white"
                              style={{ backgroundColor: "#EF6C00" }}
                              onClick={() => setShowItemModal(true)}
                              disabled={itemsList.length === 0}
                            >
                              <i className="fas fa-search" /> เลือกวัสดุ
                            </button>
                          </div>
                          {selectedItem && (
                            <div className="mt-2">
                              <small className="text-muted">
                                {selectedItem.Item_Code} -{" "}
                                {selectedItem.Item_Name}
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>คลัง:</label>
                          <select
                            className="form-control"
                            value={selectedWarehouse}
                            onChange={(e) =>
                              setSelectedWarehouse(e.target.value)
                            }
                            disabled={warehouseList.length === 0}
                          >
                            <option value="">-- เลือกคลัง --</option>
                            {warehouseList.map((warehouse) => (
                              <option
                                key={warehouse.WH_Id}
                                value={warehouse.WH_Id}
                              >
                                {warehouse.WH_Code} - {warehouse.WH_Name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-lg shadow text-white"
                        style={{
                          width: "10%",
                          marginRight: "20px",
                          backgroundColor: "#EF6C00",
                          fontSize: "16px",
                        }}
                        onClick={handleSearch}
                      >
                        <i className="fas fa-search" /> ค้นหา
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg shadow text-white"
                        style={{
                          width: "10%",
                          marginRight: "20px",
                          backgroundColor: "#EF6C00",
                          fontSize: "16px",
                        }}
                        onClick={handleExport}
                        disabled={isExporting || filteredData.length === 0}
                      >
                        <i className="fas fa-file-excel" />{" "}
                        {isExporting ? "กำลังส่งออก..." : "Export"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg shadow text-white"
                        style={{
                          width: "10%",
                          backgroundColor: "#EF6C00",
                          fontSize: "16px",
                        }}
                        onClick={initialize}
                      >
                        <i className="fas fa-undo" /> เริ่มใหม่
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 mt-4">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-start flex-wrap">
                    <div>
                      <h4>ผลการค้นหา</h4>
                      {selectedItem && (
                        <small className="text-muted">
                          วัสดุ: {selectedItem.Item_Code} -{" "}
                          {selectedItem.Item_Name}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "550px", overflowY: "auto" }}
                    >
                      <table
                        className="table table-striped table-hover"
                        ref={tableRef}
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center">วันที่</th>
                            <th className="text-center">รายละเอียด</th>
                            <th className="text-center">เลขที่</th>
                            <th className="text-center">ชื่อผู้เบิก</th>
                            <th className="text-center">ชื่อร้านค้า</th>
                            <th className="text-center">รับเข้า</th>
                            <th className="text-center">จ่ายออก</th>
                            <th className="text-center">คงเหลือ</th>
                            <th className="text-center">ราคา</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length > 0 ? (
                            currentItems.map((data, index) => {
                              const rowId = data.Doc_No || index + 1;
                              return (
                                <tr
                                  key={rowId}
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor:
                                      selectedRow === rowId
                                        ? "#f8f9fa"
                                        : "transparent",
                                    transition: "background-color 0.3s ease",
                                  }}
                                  onClick={() => setSelectedRow(rowId)}
                                >
                                  <td className="text-center">
                                    {formatDate(data.STC_Date)}
                                  </td>
                                  <td className="text-left">
                                    {data.STC_Remark || "-"}
                                  </td>
                                  <td className="text-center">
                                    {data.Doc_No || "-"}
                                  </td>
                                  <td className="text-left">
                                    {data.Requestor_Name || "-"}
                                  </td>
                                  <td className="text-left">
                                    {data.Shop_Name || "-"}
                                  </td>
                                  <td className="text-right">
                                    {data.movement_in
                                      ? formatNumber(data.movement_in)
                                      : "-"}
                                  </td>
                                  <td className="text-right">
                                    {data.movement_out
                                      ? formatNumber(data.movement_out)
                                      : "-"}
                                  </td>
                                  <td className="text-right">
                                    {formatNumber(data.STC_Balance)}
                                  </td>
                                  <td className="text-right">
                                    {formatNumber(data.Item_Price)}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                <h5>ไม่พบข้อมูล</h5>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="row mt-3">
                      <div className="col-12 d-flex justify-content-end">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="basic-datatables_paginate"
                        >
                          <ul className="pagination">
                            <li
                              className={`paginate_button page-item previous ${currentPage === 1 ? "disabled" : ""
                                }`}
                            >
                              <a
                                href="#"
                                className="page-link"
                                onClick={() => setCurrentPage(currentPage - 1)}
                              >
                                Previous
                              </a>
                            </li>
                            {renderPageNumbers()}
                            <li
                              className={`paginate_button page-item next ${currentPage ===
                                Math.ceil(filteredData.length / itemsPerPage)
                                ? "disabled"
                                : ""
                                }`}
                            >
                              <a
                                href="#"
                                className="page-link"
                                onClick={() => setCurrentPage(currentPage + 1)}
                              >
                                Next
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ItemModal
        formDetailList={[]}
        showItemModal={showItemModal}
        handleItemClose={handleItemClose}
        itemDataList={itemsList}
        onRowSelectItem={onRowSelectItem}
        singleSelect={true}
      />
    </>
  );
};

export default MaterialMovementReport;
